var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyedit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4414 19.8047H19.4829M10.3516 6.88086L15.8732 10.9384M6.98575 19.9226L8.6523 19.4378C9.54806 19.1768 10.3285 18.6192 10.8644 17.8568L17.2532 8.99764C18.018 7.94832 17.7872 6.4789 16.7379 5.71406L15.0044 4.45028C13.9553 3.68674 12.4845 3.91766 11.7208 4.96552L5.26193 13.9239C4.76904 14.6259 4.5086 15.4642 4.51577 16.3224L4.53179 18.0982C4.54389 19.369 5.76578 20.2772 6.98575 19.9226Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyedit);
export default __webpack_public_path__ + "static/media/companyedit.d5278bac4c427a181d4d1b88e17ade82.svg";
export { ForwardRef as ReactComponent };